import { useState } from 'react';
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import '../styles/login.css';

export default function ForgotPasswordForm({ onCancel, onSuccess }) {
  const [step, setStep] = useState(1); // 1 = solicitar código, 2 = confirmar nueva contraseña
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Paso 1: Solicitar código de recuperación
  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await resetPassword({ username: email });
      setMessage('Se ha enviado un código de verificación a tu email.');
      setStep(2);
    } catch (err) {
      console.error('Error al solicitar código:', err);

      let errorMessage = 'Error al solicitar código de recuperación';
      if (err.name === 'UserNotFoundException') {
        errorMessage = 'Usuario no encontrado';
      } else if (err.name === 'LimitExceededException') {
        errorMessage = 'Demasiados intentos. Intenta más tarde';
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Confirmar nueva contraseña con código
  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    // Validar que las contraseñas coincidan
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    // Validar longitud mínima
    if (newPassword.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }

    setLoading(true);

    try {
      await confirmResetPassword({
        username: email,
        confirmationCode: code,
        newPassword: newPassword
      });

      setMessage('Contraseña cambiada exitosamente');

      // Llamar callback de éxito después de un breve delay
      setTimeout(() => {
        onSuccess();
      }, 1500);
    } catch (err) {
      console.error('Error al confirmar nueva contraseña:', err);

      let errorMessage = 'Error al cambiar la contraseña';
      if (err.name === 'CodeMismatchException') {
        errorMessage = 'Código de verificación incorrecto';
      } else if (err.name === 'ExpiredCodeException') {
        errorMessage = 'El código ha expirado. Solicita uno nuevo';
      } else if (err.name === 'InvalidPasswordException') {
        errorMessage = 'La contraseña no cumple con los requisitos de seguridad';
      } else if (err.name === 'LimitExceededException') {
        errorMessage = 'Demasiados intentos. Intenta más tarde';
      } else if (err.message) {
        errorMessage = err.message;
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {step === 1 ? (
        // Paso 1: Solicitar código
        <>
          <p style={{ marginBottom: '15px', fontSize: '14px', color: '#666' }}>
            Ingresa tu email para recibir un código de recuperación
          </p>

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          <form onSubmit={handleRequestCode}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              autoFocus
            />

            <button type="submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Código'}
            </button>

            <button
              type="button"
              className="secondary-button"
              onClick={onCancel}
              disabled={loading}
            >
              Cancelar
            </button>
          </form>
        </>
      ) : (
        // Paso 2: Confirmar nueva contraseña
        <>
          <p style={{ marginBottom: '15px', fontSize: '14px', color: '#666' }}>
            Ingresa el código enviado a {email} y tu nueva contraseña
          </p>

          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          {message && (
            <div className="alert alert-success">
              {message}
            </div>
          )}

          <form onSubmit={handleConfirmReset}>
            <input
              type="text"
              placeholder="Código de verificación"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              disabled={loading}
              maxLength={6}
              autoFocus
            />

            <input
              type="password"
              placeholder="Nueva contraseña"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
            />

            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              minLength={8}
            />

            <button type="submit" disabled={loading}>
              {loading ? 'Cambiando...' : 'Cambiar Contraseña'}
            </button>

            <button
              type="button"
              className="secondary-button"
              onClick={onCancel}
              disabled={loading}
            >
              Cancelar
            </button>
          </form>

          <div style={{ marginTop: '15px', textAlign: 'center' }}>
            <button
              type="button"
              className="link-button"
              onClick={() => setStep(1)}
              disabled={loading}
            >
              ¿No recibiste el código? Solicitar otro
            </button>
          </div>
        </>
      )}
    </div>
  );
}